import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';

import { FormBuilder, FormGroup } from '@angular/forms';

 
import { environment } from 'src/environments/environment.prod';
import { Pjoint } from 'src/app/entity/Pjoint';
import { Stand } from 'src/app/entity/Stand';
import { Facture } from 'src/app/entity/Facture';
import { Client } from 'src/app/entity/exhibitor';
import { FactureService } from 'src/app/service/facture.service';
import { AppSettings } from 'src/app/service/app.setting';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { MailsService } from 'src/app/service/mails.service';
import { ComposeMailComponent } from '../../email/include/compose-mail/compose-mail.component';
 

@Component({
  selector: 'app-result-form',
  templateUrl: './result-form.component.html',
  styleUrls: ['./result-form.component.scss']
})

export class ResultFormComponent implements OnInit {
  uploadUrl: String = environment.restApiCRM + 'mails/upload1';

  @Input()
  idClient: number;

  @ViewChild(ComposeMailComponent )
  private composeMailComponent: ComposeMailComponent;

  client: Client;
  contrat: Facture;
  stands: Stand[];
  file: any;
  uploadedFiles: any[] = [];
  isClient: boolean;
  isContrat: boolean;
  isStands: boolean;
  groupeForm: FormGroup;
  pjoints: Pjoint[];
  observationd: string;
  constructor(private clientService: ExhibitorService, private fb: FormBuilder, private factureService: FactureService,
    private exhibitorService:ExhibitorService,private mailsService:MailsService
    ) {
    this.buildForm();

  }

  ngOnInit(): void {
    this.clientService.getExhibitor(this.idClient).subscribe(result => {
//console.log("this.observationd"+this.observationd);

this.observationd=result.observation;
      this.client = result;
      if (this.client.pjointContrat)
        this.openContract(this.client.pjointContrat, false,false)
      this.buildFormClient(this.client)
      this.isClient = true;
    });


    this.clientService.findContratClient(this.idClient).subscribe(result => {
      this.contrat = result;
      this.isContrat = true;

    })

    this.findAllPjoint()

  }

editRemarqu(){
  //console.log(this.observationd);
 
  this.clientService.editRemarque(this.idClient,this.observationd).subscribe()

  
}

  findAllPjoint() {
    this.clientService.getPjointsClient(this.idClient).subscribe(result => {
      this.pjoints = result


    })
  }
  buildForm(): void {
    this.groupeForm = this.fb.group({
      'raisonSocial': ['']
    });
  }


  getClientContract(download: boolean,isSend:boolean) {
    this.clientService.getExhibitor(this.idClient).subscribe(result => {


      this.client = result;
      if (this.client.pjointContrat)
        this.openContract(this.client.pjointContrat, download,isSend)

    });

  }

  buildFormClient(client: Client): void {
    //console.log('client.prospectId.raisonSocial ' + client.prospectId.raisonSocial);

    this.groupeForm.patchValue({
      'raisonSocial': client.prospectId.raisonSocial,

    });
  }



  attache(divId: string) {

    const container = document.querySelector(divId);

    container.querySelectorAll('input[type=file]')[0]['click']();

  }
  onUploadPjoint(event) {
     this.file = null;
    for (const file of event.files) {

      this.file = file;
    }
    this.addPjoint("pjointclient");
  }
  onUploadContrat(event) {

    this.file = null;
    for (const file of event.files) {

      this.file = file;
    }

    this.addPjoint("contrat");
  }
  addPjoint(folder: string) {

    const fd = new FormData();
    if (this.file) {

      fd.append('file', this.file, this.file.name);
    }

    fd.append('data', JSON.stringify(this.client));

    this.clientService.addPjoint(fd, folder).subscribe(result => {
      if (AppSettings.CONTRACT_FOLDER === folder)

        this.getClientContract(false,false);
      this.findAllPjoint();
    });
  }
  openPjoint(pjoint: Pjoint, download: boolean) {
 
    this.openFile(pjoint, download, pjoint.folder,false);
  }
  fileURL: string;
  openFile(pjoint: Pjoint, download: boolean, folder: string,isSend:boolean) {
    this.factureService.pjointFile(pjoint, folder).subscribe(res => {
     // res.name = pjoint.fileName;
      //    saveAs(res, res.name);
      let fileURL = URL.createObjectURL(res);
      this.fileURL = fileURL;
      if (download)
        window.open(fileURL);
        else if(isSend)
        this.sendDossier(res)
    }, (err) => { //console.log('aeeeerrrree' + err); 
    });
  }
  openContract(pjoint: Pjoint, download: boolean, isSend: boolean) {
    this.openFile(pjoint, download, AppSettings.CONTRACT_FOLDER,isSend);
  }
 

  remove(pjoint: Pjoint) {
    this.factureService.removePjoint(pjoint).subscribe(result => {
      this.findAllPjoint();
    });
  }
 
  sendDossierProforma(ficheExposant ) {
      this.uploadedFiles = []
      let contract:Facture;
      this.exhibitorService.findContratClient(this.idClient).subscribe(result => {
          contract=result;
          let isEnglish:boolean;
if(this.client.prospectId.langue=='EN')
isEnglish=true;
                  this.factureService.printPersonaliser(result, isEnglish,true,"","","",false).subscribe(
              (res: any) => {
                let proforma="";
  if(!result.aclasser)
proforma='Proforma';
                  var filename = this.client.prospectId.raisonSocial+'_facture'+proforma+'.pdf';
  
                  filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
                
                  res.name = filename;
                  this.uploadedFiles.push(res);
                  this.uploadedFiles.push(ficheExposant);
                  this.mailsService.findodel(13).subscribe(result=>{
               
                      this.composeMailComponent.prepareEmailModel(result, this.client.contact, "NAPEC", contract.prospectprospectId, this.uploadedFiles)
              
  
  
                //  var fileURL = URL.createObjectURL(res);
              //    window.open(fileURL);
  
              });
      })
  
  
       
  
    })
  }
  sendDossier(res) {
   
  
  this.sendDossierProforma(res)
   
  }


  sendContractClient(){
    this.getClientContract(false,true);
  }
}
